import React, { useState } from 'react';
import { Button, Form, Modal, notification, Select } from 'antd';
import { assignLiftoffUserRoles } from '../../api/liftoffUserApi';
import { EditOutlined } from '@ant-design/icons';

const EditRolesButton = ({user, allRoles, onComplete, style}) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  const FORM_ROLES_NAME = 'Roles';

  const cancel = () => {
    form.resetFields([FORM_ROLES_NAME]);
    setShowModal(false);
  };

  const showError = message => {
    notification.error({
      message: 'Edit Roles Failed',
      description: message,
      placement: 'bottomRight',
    });
  };

  const submit = async () => {
    try {
      setLoading(true);
      const newRoles = form.getFieldValue(FORM_ROLES_NAME);
      const response = await assignLiftoffUserRoles(user.email, newRoles);

      if (response && response.status && response.status === 200) {
        notification.success({
          message: 'Success',
          description: `Roles for ${user.email} have been updated!`,
          placement: 'bottomRight',
        });
        onComplete();
      } else {
        showError(`Roles for ${user.email} could not be updated. Please contact na_opsenablement@credera.com`);
      }
    } catch (e) {
      showError(`Roles for ${user.email} could not be updated. Please contact na_opsenablement@credera.com. Error: ${e.message}`);
    } finally {
      setLoading(false);
      setShowModal(false);
      form.resetFields();
    }
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} loading={loading} icon={<EditOutlined/>} style={style}>
        Edit Roles
      </Button>

      {showModal && (
        <Form name="liftoff-edit-user-roles" form={form} onFinish={submit}>
          <Modal
            title={`Edit Roles for ${user.email}`}
            open={showModal}
            footer={[
              <Button key="cancel" onClick={cancel}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={() => form.submit()} loading={loading}>
                Save
              </Button>
            ]}
          >
            <Form.Item label="Roles" name={FORM_ROLES_NAME} rules={[{required: true}]} initialValue={user.roles.map(r => r.role)}>
              <Select mode="multiple" placeholder="Select role(s)">
                {allRoles.map(r => (
                  <Select.Option key={r} value={r}>
                    {r}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Modal>
        </Form>
      )}
    </>
  );
};

export { EditRolesButton };